import { NgClass } from '@angular/common'
import { Component, inject, Input } from '@angular/core'
import { HtmlAttributesDirective } from 'src/app/shared/directives/html-attributes.directive'
import { SidebarNavBadgePipe } from '../sidebar-nav-badge.pipe'
import { SidebarNavHelper } from '../sidebar-nav.service'

@Component({
    selector: 'sf-sidebar-nav-label',
    imports: [HtmlAttributesDirective, SidebarNavBadgePipe, NgClass],
    templateUrl: './sidebar-nav-label.component.html',
    styleUrl: './sidebar-nav-label.component.scss',
})
export class SidebarNavLabelComponent {
    readonly helper = inject(SidebarNavHelper)

    @Input() item: any

    private classes = {
        'c-nav-label': true,
        'c-active': true,
    }
    private iconClasses = {}

    ngOnInit() {
        this.iconClasses = this.helper.getIconClass(this.item)
    }

    getItemClass() {
        const itemClass = this.item.class
        // @ts-ignore
        this.classes[itemClass] = !!itemClass
        return this.classes
    }

    getLabelIconClass() {
        const variant = `text-${this.item.label.variant}`
        // @ts-ignore
        this.iconClasses[variant] = !!this.item.label.variant
        const labelClass = this.item.label.class
        // @ts-ignore
        this.iconClasses[labelClass] = !!labelClass
        return this.iconClasses
    }
}
